import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Gmail Send Email v2 Configuration Validator
 * Validates Gmail email configuration including connection, recipients, content, and attachments
 */
export const Gmail_Send_Email_2_ConfigValidator = z.object({
    gmailConnection: requiredString('Gmail Connection is required'),
    emailFrom: requiredString('From Email is required'),
    emailTo: requiredString('To Email is required'),
    emailCc: z.string().optional(),
    emailSubject: requiredString('Email Subject is required'),
    emailBody: requiredString('Email Body is required'),
    emailHasSignature: z.boolean().default(false),
    includeAttachments: z.boolean().default(false)
});
//# sourceMappingURL=gmail-send-email-2.js.map